const Footer = () => {
  return (
    <article className="footer">
      <a
        href="https://github.com/tien2612/"
        target="_blank"
        rel="noreferrer"
      >
      </a>
    </article>
  );
};

export default Footer;
